import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function updateUserInfo(data) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/userinfo",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
